<template>
  <div>
    <ManagerSearch v-bind:queryParams="queryParams" v-bind:fullDate="fullDate"/>
    <ManagerList v-bind:queryParams="queryParams" v-bind:fullDate="fullDate" v-bind:fields="fields"/>
  </div>
</template>
<script>


import DatePicker from "vue2-datepicker";
import ManagerSearch from "./manager/component/ManagerSearch";
import ManagerList from "./manager/component/ManagerList";
const moment = require("moment");

export default {
  name: 'ContentStatistics',
  components: {
    ManagerList,
    ManagerSearch,
    DatePicker,
  },
  data() {
    return {

      fullDate: [],
      queryParams: {
        authority: 'all',
        status: 'all',
        search_type: 'all',

        start_date: '',
        end_date: '',
        keyword: '',
      },

      fields: [  '선택'
        , {'authority_name': {'label': '권한등급',}}
        , {'manager_id': {'label': '아이디',}}
        , {'name': {'label': '이름',}}
        , {'department': {'label': '부서',}}
        , {'status_name': {'label': '권한상태',}}
        , {'reg_date': {'label': '가입일',}}
      ],

    }
  },
  computed: {
    listRows () {
      return this.items.length
    }
  },
  mounted: function() {
  },
  methods: {

    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },

  }
}


</script>



// WEBPACK FOOTER //
// src/views/common/ManagerManagement.vue